module.exports = __webpack_public_path__ + "img/new_vip_face0.74a37163.jpg";